import moment from "moment";
import {useContext, useEffect, useState} from "react";
import Loader from "../../Tools/Loader";
import Form from "./Form";
import UserContext from '../../../services/Context/UserContext'
import Icon from "./Icon";
import { Button, Typography } from "@mui/material";
import '../../../css/activities.css'
import Activity from "./Activity";
import Stats from "./Stats";
import {Stack, Box} from "@mui/material";
import Filter from "./Filter";
import API from "../../../services/API";
import Range from "../../Inputs/Range";

const types = ['note', 'reminder', 'email', 'deal', 'call'];


export default function Index({person, creator}){

    const {user} = useContext(UserContext)

    const [activities, setActivities] = useState([]);

    const [loading, setLoading] = useState(true);

    const [form, setForm] = useState(false);

    const [show, setShow] = useState({
        note: true,
        reminder: true,
        deal: true,
        email: true,
        call: true,
        flag: true
    });


    const [period, setPeriod] = useState(null)

    const [limit, setLimit] = useState(100)

    useEffect(() => {

        let range = {
            start: moment().add(-15, 'days').format('YYYY-MM-DD'),
            end: moment().endOf('day').format('YYYY-MM-DD')
        };

        setPeriod(range)

        fetchActivities(person?.id, range)
            .then(r => {
                setActivities(r.data);
                setLoading(false)
            })
            .catch(e => console.log(e?.response?.data))
        
    }, [person])


    const showForm = type => {
        return setForm({
            user: person || user,
            type: {id: type}
        })
    }


    const handleAdd = activity => {
        let copy = [...activities]
        copy.push(activity)
        setActivities(copy)
        setForm(false);
    }

    const handleDelete = id => {
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer cette action ?");
        if(!ok) return false;

        let old = [...activities];

        let copy = [...activities];
        copy = copy.filter(a => a.id !== id);
        setActivities(copy);

        API.delete(`/crm/activities/${id}`)
            .then(r => console.log(r))
            .catch(e => setActivities(old))
    }


    const handleShow = type => {
        let copy = {...show};
        copy[type] = !copy[type];
        return setShow(copy);
    }

    const match = i => show[i.type?.id]

    const handlePeriod = range => {

        setPeriod(range)
        setLoading(true)
        setActivities([]);

        fetchActivities(person?.id, range)
            .then(r => {
                setActivities(r.data);
                setLoading(false)
            })
            .catch(e => console.log(e?.response?.data))
    }

    return <Stack spacing={1.5}>

        {creator &&
            <Stats activities={activities} />
        }

        {!creator && 
            <Typography variant='h3'>Activités</Typography>
        }

        <Stack direction='row' spacing={1}>

            <Button variant='outlined' onClick={() => showForm('note')} startIcon={<Icon type='note' color='inherit'/>}>Note</Button>

            <Button variant='outlined' onClick={() => showForm('reminder')} startIcon={<Icon type='reminder' color='inherit'/>}>Rappel</Button>

            {!creator && <>

                <Button variant='outlined' onClick={() => showForm('deal')} startIcon={<Icon type='deal' color='inherit'/>}>Affaire</Button>
                    
                <Button variant='outlined' onClick={() => showForm('email')} startIcon={<Icon type='email' color='inherit'/>}>Email</Button>

                <Button variant='outlined' href={'tel:' + person.phone} startIcon={<Icon type='call' color='inherit'/>}>Appel</Button>

            </>}

        </Stack>
            


        <Stack direction='row' justifyContent='space-between' alignItems='center' flexWrap='wrap'>

            <Stack direction='row' spacing={3}>

                {types.map(t => 
                    <Filter
                        key={t} 
                        type={t} 
                        toggle={show[t]} 
                        count={activities.filter(a => a.type?.id === t).length}
                        onClick={() => handleShow(t)}
                    /> 
                )}

            </Stack>

            {period && 
                <Range 
                    start={period.start}
                    end={period.end}
                    onChange={handlePeriod}
                    sx={{m: 1}}
                />
            }

        </Stack>


        {loading && <Loader />}
            
        <Box>
            {activities
                .filter(i => match(i) )
                .sort((a, b) => moment(b.sortDate).valueOf() - moment(a.sortDate).valueOf())
                .slice(0, limit)
                .map(a => 
                    <Activity 
                        activity={a} 
                        onDelete={() => handleDelete(a.id)} 
                        key={a.id}
                    />
                )
            }
        </Box>


        {activities.length > limit &&
            <Button onClick={() => setLimit(limit + 100)}>
                Afficher la suite
            </Button>
        }


        <Form 
            open={form ? true : false}
            data={form} 
            onClose={() => setForm(false)}
            onSuccess={activity => handleAdd(activity)}
        />

    </Stack>
    
}



const fetchActivities = async (userId, dateRange) => {

    let since = dateRange.start + 'T00:00:00.000';
    
    let until = dateRange.end + 'T23:59:59.999';

    if(userId){

        return await API.get(`/crm/users/${userId}/activities?since=${since}&until=${until}`);
    
    }else{

        return await API.get(`/crm/activities?since=${since}&until=${until}`);
    }
}